export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/5705871e133a048fcd13b20b6e4d74bd/26d8c27b87decb516fa51c337abf97bb.jpeg" 
                alt="ESAPCOR Logo" 
                className="h-20 w-auto object-contain"
              />
            </div>
            <div className="flex space-x-4">
              <a 
                href="https://www.facebook.com/esapcorporation" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-orange-600 transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a 
                href="https://www.youtube.com/channel/UCEmNCMlXdsQNxt2eeKkuEtw" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-orange-600 transition-colors cursor-pointer"
              >
                <i className="ri-youtube-fill text-xl"></i>
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-orange-600 transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-orange-600 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6 text-orange-400">Liên kết nhanh</h3>
            <ul className="space-y-3">
              <li><a href="#benefits" className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer text-sm">Lợi ích</a></li>
              <li><a href="#programs" className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer text-sm">Chương trình đào tạo</a></li>
              <li><a href="#kits" className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer text-sm">Robotics Kits</a></li>
              <li><a href="#partnership" className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer text-sm">Nhượng quyền</a></li>
              <li><a href="#gallery" className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer text-sm">Gallery</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6 text-orange-400">Thông tin liên hệ</h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <i className="ri-global-line text-orange-400 mr-3 mt-1 flex-shrink-0"></i>
                <div>
                  <p className="text-sm text-gray-400">Website</p>
                  <a 
                    href="https://robotics.esapcor.vn" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="text-white font-semibold hover:text-orange-400 cursor-pointer"
                  >
                    robotics.esapcor.vn
                  </a>
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-phone-fill text-orange-400 mr-3 mt-1 flex-shrink-0"></i>
                <div>
                  <p className="text-sm text-gray-400">Hotline</p>
                  <div className="flex flex-col space-y-1">
                    <a href="tel:0902768879" className="text-white font-semibold hover:text-orange-400 cursor-pointer">0902 768 879</a>
                    <a href="tel:0977276143" className="text-white font-semibold hover:text-orange-400 cursor-pointer">0977 276 143</a>
                  </div>
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-mail-fill text-orange-400 mr-3 mt-1 flex-shrink-0"></i>
                <div>
                  <p className="text-sm text-gray-400">Email</p>
                  <a href="mailto:info@esapcor.vn" className="text-white font-semibold hover:text-orange-400 cursor-pointer">info@esapcor.vn</a>
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-map-pin-fill text-orange-400 mr-3 mt-1 flex-shrink-0"></i>
                <div>
                  <p className="text-sm text-gray-400">Địa chỉ</p>
                  <div className="text-white text-sm space-y-1">
                    <p><strong>Trụ sở:</strong> 128/55/1/22 Lý Văn Sâm, Kp.5, P. Tam Hiệp, T. Đồng Nai</p>
                    <p><strong>VP:</strong> 128/55 Lý Văn Sâm, Kp.5, P. Tam Hiệp, T. Đồng Nai</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6 text-orange-400">Giờ làm việc</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex justify-between">
                <span className="text-gray-400">Thứ 2 - Thứ 6:</span>
                <span className="text-white font-semibold">8:00 - 20:00</span>
              </li>
              <li className="flex justify-between">
                <span className="text-gray-400">Thứ 7 - CN:</span>
                <span className="text-white font-semibold">8:00 - 18:00</span>
              </li>
            </ul>
            <div className="mt-6 p-4 bg-white/5 rounded-lg border border-white/10">
              <p className="text-sm text-gray-400 mb-2">Nhận thông tin mới nhất</p>
              <div className="flex">
                <input 
                  placeholder="Email của bạn" 
                  className="flex-1 px-3 py-2 bg-white/10 border border-white/20 rounded-l-lg text-sm text-white placeholder-gray-500 focus:outline-none focus:border-orange-400" 
                  type="email"
                />
                <button className="whitespace-nowrap bg-orange-600 px-4 py-2 rounded-r-lg hover:bg-orange-700 transition-colors cursor-pointer">
                  <i className="ri-send-plane-fill"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">© 2026 Công ty TNHH ESAPCOR. All rights reserved.</p>
            <div className="flex items-center space-x-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer">Chính sách bảo mật</a>
              <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer">Điều khoản sử dụng</a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer">Website Builder</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}